type ShortlistData = {
    items: number[];
    comparingItems: number[];
    showAll: string;
    sellerCollapsed: string;
    techOpened: string;
    isComparing: string;
};

type BooleanProp = 'showAll' | 'sellerCollapsed' | 'techOpened' | 'isComparing';
type ShortlistProp = 'items' | 'comparingItems' | BooleanProp;

class LocalStorage {
    storage: Storage;
    key: string;

    constructor (storage: Storage) {
        this.key = '';
        this.storage = storage;
    }

    setKey (key: string) {
        this.key = key;
    }

    getShortlistItems (): number[] {
        const data = this.get();
        return data && data.items ? data.items : [];
    }

    getComparingItems (): number[] | null {
        const data = this.get();
        return data && data.comparingItems ? data.comparingItems : null;
    }

    getState (): ShortlistData {
        const data = this.get();
        return data || {} as ShortlistData;
    }

    private get (): ShortlistData | null {
        try {
            const data = this.storage.getItem(this.key);
            return data
                ? JSON.parse(data) as ShortlistData
                : null;
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    setBoolean (key: ShortlistProp, value: boolean): void {
        this.set(key, value ? '1' : '');
    }

    /* eslint-disable @typescript-eslint/no-explicit-any */
    set (key: ShortlistProp, value: any): void {
        try {
            let data = this.get();
            if (!data) {
                data = {} as ShortlistData;
            }
            data[key] = value;
            this.storage.setItem(this.key, JSON.stringify(data));
        } catch (e) {
            console.error(e);
        }
    }

    unset (key: ShortlistProp): void {
        try {
            const data = this.get();
            if (!data || !data[key]) {
                return;
            }
            delete data[key];
            this.storage.setItem(this.key, JSON.stringify(data));
        } catch (e) {
            console.error(e);
        }
    }
}

const localStorage = new LocalStorage(window.localStorage);

export function useLocalStorage (): LocalStorage {
    return localStorage;
}
